import type { DehydratedState } from "@tanstack/vue-query";

// The app renders on the client only, so @hebilicious/vue-query-nuxt finds no
// dehydrated state to hydrate. @tanstack/query-core >= 5.103 no longer accepts
// a missing state, so an empty one is provided before that plugin runs.
// eslint-disable-next-line no-restricted-exports
export default defineNuxtPlugin({
    name: "vue-query-state",
    enforce: "pre",
    setup(nuxtApp) {
        useState<DehydratedState>(
            nuxtApp.$config.public.vueQuery.stateKey,
            () => ({ mutations: [], queries: [] }),
        );
    },
});
